import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource-variable/alexandria/wght.css";
import App from "./App";
import "./styles.css";
import "./premium.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
